import { TemplatePrompts } from '@kimuno/api-sdk';

import { aiAssistantPageSource, campaign, routes } from '../../constants';
import { LAUNCH_PARAM_KEYS } from '../AIAssistant/shared/templateLaunchParams';

export interface PromoCampaign {
	id: string;
	headlineKey: string;
	bodyKey: string;
	ctaKey: string;
	ctaRoute: string;
	/** Optional secondary (outlined) CTA. Both must be set for it to render. */
	secondaryKey?: string;
	secondaryRoute?: string;
	/** Amplitude `campaign` name for the MessageDisplayed impression event. */
	trackingCampaign: string;
}

export const podcastLaunchCampaignId = 'podcast-launch';

// The `triggeredHints` key a campaign banner's dismissal is persisted under.
export const promoBannerHintKey = (campaignId: string) => `promo-banner-${campaignId}`;

// Keyed by campaign id. Add an entry per campaign; the active one is chosen by the container.
const campaigns: Record<string, PromoCampaign> = {
	[podcastLaunchCampaignId]: {
		id: podcastLaunchCampaignId,
		headlineKey: 'New in the Mukibude: AI Podcast',
		bodyKey: 'Turn your teaching content into ready-made audio episodes – quick and easy.',
		ctaKey: 'Create podcast',
		// Deep-links straight into the podcast creation form via the validated
		// launch-param mechanism (templateLaunchParams.ts); school users fall back
		// to the Muki landing there. page_source attributes the AI Assistant events
		// of the launched flow to the dashboard.
		ctaRoute:
			`/${routes.aiTools.root}?${LAUNCH_PARAM_KEYS.template}=${TemplatePrompts.CREATE_PODCAST}` +
			`&page_source=${aiAssistantPageSource.dashboard}`,
		trackingCampaign: campaign.dashboardPodcastPromo,
	},
};

export const getPromoCampaign = (variant?: string): PromoCampaign | undefined =>
	variant ? campaigns[variant] : undefined;
